<template>
  <div class="userManage">
    <Modal v-if="isModalVisible" 
        :dialog-type="modalType"
        :hideHeaderClose="hideHeaderClose"
    >
        <template v-slot:header>{{modalTitle}}</template>
        <template v-slot:footer v-if="modalFooter">
            <Button :button-type="'button'"
                    class="actionButton"
                    :button-style="'buttonText'"
                    @on-click="updateTable(currentStatus)">{{STATUS.ACTION[currentStatus]}}</Button>
            <Button :button-type="'button'"
                    class="cancelButton"
                    :button-style="'buttonText'"
                    @on-click="closeModal()">Cancel</Button>
        </template>
        {{modalMessage}}
    </Modal>
    <div class="tableToolbar">
        <user-filter/>
        <user-update/>
    </div>
    <user-table :rowData="this.users"/>
    <SeatCount/>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import UserTable from './UserTable.vue';
import UserUpdate from './UserUpdate.vue';
import UserFilter from './UserFilter.vue';
import Modal from '../shared/Modal.vue';
import Button from '../shared/Button.vue';
import SeatCount from './SeatCount.vue';
import { 
    STATUS, 
    RESPONSE_STATUSES, 
    ERROR_MESSAGE, 
    USER_UPDATE,
    MODAL_MESSAGE
} from '../shared/constants';
import {
    SET_SELECTED_USERS,
    SET_ERROR_STATE,
    SET_AUTH_TOKEN,
    SET_FULLY_LOGGED_IN,
    SET_ERROR_TITLE,
    SET_ERROR_BODY
} from '../../store/manage.store';

export default {
    components: {
        UserUpdate,
        UserFilter,
        UserTable,
        Modal,
        Button,
        SeatCount
    },
    data() {
        return {
            STATUS,
            hideHeaderClose: false
        }
    },
    computed: {
        ...mapGetters([
            'users',
            'isModalVisible',
            'modalMessage',
            'modalTitle',
            'modalFooter',
            'modalType',
            'selectedActiveUsers',
            'selectedUserIds',
            'error',
            'seatCount',
            'activeUsers'
        ]),
        currentStatus() {
            return this.selectedActiveUsers ? 'Disabled' : 'Active';
        }
    },
    beforeDestroy() {
        this[SET_SELECTED_USERS]([]);
        this.$root.$off("updatedUserStatus");
    },
    async beforeMount() {
        this.hideModal();
        this[SET_ERROR_TITLE](ERROR_MESSAGE.DEFAULT.title);
        this[SET_ERROR_BODY](ERROR_MESSAGE.DEFAULT.body);
        
        try {
            await this.getUsers()
                .then(() => {
                    if (this.error) {
                        this[SET_ERROR_STATE](false);
                        this.$router.push("/manage");
                    }
                    this[SET_FULLY_LOGGED_IN](true);
                });
            this.getAccount();
        }
        catch(error) {
            if (
                error === RESPONSE_STATUSES.AUTHENTICATION_FAILED ||
                error === RESPONSE_STATUSES.AUTHORIZATION_FAILED
            ) {
                this.logoutUser();
            }
            else {
                this.showModal(MODAL_MESSAGE.ERROR("Action"));
            }
        }
    },
   
    methods: {
        ...mapActions([
            'getAccount',
            'getUsers',
            'hideModal',
            'updateUsers',
            'showModal',
            'getFilteredUsers', 
            'logoutUser'
        ]),
        ...mapMutations([
            SET_SELECTED_USERS,
            SET_ERROR_STATE,
            SET_AUTH_TOKEN,
            SET_FULLY_LOGGED_IN,
            SET_ERROR_TITLE,
            SET_ERROR_BODY
        ]),
        closeModal() {
            this.hideModal();
        },
        async updateTable(status) {
            this.hideModal();
            await this.updateUsers({status})
                .then(() => {
                    this.hideHeaderClose = true;
                    this.showModal(MODAL_MESSAGE.LOADING());

                    let updated = false;
                    let currentUsers = this.users;
                    let numAttempts = USER_UPDATE.ATTEMPTS;
                    let numSelected = this.selectedUserIds.length;

                    for (let i = 0; i < numAttempts; i++) {
                        setTimeout(async () => {
                            if (!updated) {
                                await this.getFilteredUsers();

                                if (JSON.stringify(currentUsers) !== JSON.stringify(this.users)) {
                                    this.$root.$emit("updatedUserStatus", status, numSelected);
                                    this.hideHeaderClose = false;
                                    this.showModal(MODAL_MESSAGE.SUCCESS(numSelected, status));

                                    updated = true;
                                    currentUsers = this.users;
                                } else if (i === numAttempts - 1) {
                                    this.$root.$emit("updatedUserStatus", status, numSelected);
                                    this.hideHeaderClose = false;
                                    this.showModal(MODAL_MESSAGE.SUCCESS_REFRESH(numSelected, status));
                                }
                            }
                            
                        }, USER_UPDATE.TIMEOUT * i);
                    }
                })
                .catch((error) => {
                    if (
                        error === RESPONSE_STATUSES.AUTHENTICATION_FAILED ||
                        error === RESPONSE_STATUSES.AUTHORIZATION_FAILED
                    ) {
                        this.logoutUser();
                    }
                    else if (error === RESPONSE_STATUSES.INTERNAL_SERVER && status.localeCompare('Active') === 0) {
                       this.showModal(MODAL_MESSAGE.SEATS_EXCEEDED(this.selectedUserIds, this.seatCount, this.activeUsers)); 
                    }
                    else {
                        this.showModal(MODAL_MESSAGE.ERROR(`${STATUS.ACTION[this.currentStatus]} action`));
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.userManage {
    display: flex;
    flex-direction: column;
    padding-top: 35px;
    margin-left: 56px;
    max-width: 100%;
    margin-right: 129px;
    padding-bottom: 144px;
}

.actionButton {
    margin-right: 16px;
    padding-left: 0px;
}

.tableToolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    margin-bottom: 32px;   
}
</style>